import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Icons from "../common/icons/icons";


function ExcelExport({ data, classes, containerClass, name = 'Export as Excel' }) {
  const flattenData = (data) => {
    return data.map((cl) => ({
      'Account Name': `${cl.firstName} ${cl.lastName}`,
      'Email':cl.userName,
      'Role': cl.roleName,
    }));
  };

  const exportToExcel = () => {
    const flattenedData = flattenData(data);

    if (!Array.isArray(flattenedData)) {
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, "Account.xlsx");
  };

  return (
    <div className={`py-5 flex justify-center lg:block ${containerClass}`}>
      <button
        onClick={exportToExcel}
        className={`py-2.5 px-5 me-2 text-sm mb-3 font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 ${classes}`}
      >
       <div className='flex'><Icons status={'excel'} /><div className="ml-3">{name}</div></div>
      </button>
    </div>
  );
}

export default ExcelExport;